<template>
  <div
    v-if="isVisible"
    :style="`backdrop-filter: blur(6px); background-color: ${backgroundColorRGBA}; width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 2147483647;`"
  >
    <v-container class="fill-height align-center justify-center text-center">
      <v-row dense>
        <v-col cols="12">
          <v-progress-circular
            :color="progressColorClass"
            :size="progressSize"
            :width="progressWidth"
            indeterminate
          />
        </v-col>

        <v-col
          v-if="title"
          cols="12"
        >
          <h2 v-safe-html="title" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name      : 'LoadingModal',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    backgroundColorRGBA: {
      type   : String,
      default: 'rgba(0,0,0,0.75)'
    },
    progressColorClass: {
      type   : String,
      default: 'red accent-4'
    },
    progressSize: {
      type   : Number,
      default: 64
    },
    progressWidth: {
      type   : Number,
      default: 5
    },
    title: {
      type   : String,
      default: ''
    },
    visible: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    isVisible() {
      return this.visible
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  activated() {
  },
  deactivated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
